import { render, staticRenderFns } from "./xunfang_ngz.vue?vue&type=template&id=2b823c10"
import script from "./xunfang_ngz.vue?vue&type=script&lang=js"
export * from "./xunfang_ngz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports